import { render, staticRenderFns } from "./PopupCoupons.vue?vue&type=template&id=79dc4aaa"
import script from "./PopupCoupons.vue?vue&type=script&lang=js"
export * from "./PopupCoupons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports